import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000/api/v1'

export default {
  namespaced: true,
  state: {
    files: [],
    uploadedFiles: [],
    loading: false,
    error: null,
    success: null,
    currentPatientId: null,
    userCountry: '',
    bucketName: ''
  },
  mutations: {
    SET_FILES(state, files) {
      state.files = files
    },
    SET_UPLOADED_FILES(state, files) {
      state.uploadedFiles = files
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_SUCCESS(state, message) {
      state.success = message
    },
    SET_CURRENT_PATIENT_ID(state, patientId) {
      state.currentPatientId = patientId
    },
    ADD_UPLOADED_FILE(state, file) {
      state.uploadedFiles.unshift(file)
    },
    SET_USER_COUNTRY(state, country) {
      state.userCountry = country
    },
    SET_BUCKET_NAME(state, bucketName) {
      state.bucketName = bucketName
    }
  },
  actions: {
    async uploadFile({ commit, dispatch }, fileData) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_SUCCESS', null)
      
      try {
        const formData = new FormData()
        formData.append('file', fileData)
        
        const response = await axios.post(`${API_URL}/files/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        
        // Si el archivo se subió correctamente
        if (response.data.success) {
          commit('SET_SUCCESS', 'Archivo subido correctamente')
          commit('SET_CURRENT_PATIENT_ID', response.data.patient_id)
          
          // Obtener los archivos recién subidos
          await dispatch('fetchMyUploadedFiles')
        }
        
        return response.data
      } catch (error) {
        console.error('Error al subir archivo:', error)
        commit('SET_ERROR', error.response?.data?.detail || 'Error al subir el archivo')
        return { success: false, error: error.response?.data?.detail }
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async fetchFilesByPatient({ commit }, patientId) {
      commit('SET_LOADING', true)
      
      try {
        const response = await axios.get(`${API_URL}/files/patient/${patientId}`)
        commit('SET_FILES', response.data)
        return response.data
      } catch (error) {
        console.error('Error al obtener archivos del paciente:', error)
        commit('SET_ERROR', error.response?.data?.detail)
        return []
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async fetchMyUploadedFiles({ commit }) {
      commit('SET_LOADING', true)
      
      try {
        const response = await axios.get(`${API_URL}/files/my-uploads`)
        commit('SET_UPLOADED_FILES', response.data)
        return response.data
      } catch (error) {
        console.error('Error al obtener mis archivos subidos:', error)
        commit('SET_ERROR', error.response?.data?.detail)
        return []
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    clearErrors({ commit }) {
      commit('SET_ERROR', null)
      commit('SET_SUCCESS', null)
    },
    
    updateUserCountryAndBucket({ commit, rootState }) {
      // Obtener el país del usuario desde el estado auth
      const currentUser = rootState.auth.currentUser;
      console.log("Usuario actual:", currentUser);
      
      if (currentUser) {
        // Asegurar que el país sea visible para depuración
        console.log("País del usuario:", currentUser.country);
        
        // Verificar si el país está definido
        if (currentUser.country) {
          commit('SET_USER_COUNTRY', currentUser.country);
        } else {
          console.warn("El país del usuario no está definido");
          commit('SET_USER_COUNTRY', 'No especificado');
        }
        
        // Determinar el nombre del bucket según el país
        let bucketName = 'bioportalarg'; // Default a Argentina
        
        if (currentUser.country) {
          switch(currentUser.country) {
            case 'Argentina':
              bucketName = 'bioportalarg';
              break;
            case 'México':
              bucketName = 'bioportalmex';
              break;
            case 'Brasil':
              bucketName = 'bioportalbra';
              break;
            default:
              console.log(`País desconocido: ${currentUser.country}, usando bucket por defecto`);
              bucketName = 'bioportalarg';
          }
        }
        
        commit('SET_BUCKET_NAME', bucketName);
      } else {
        console.warn("No hay usuario autenticado");
        commit('SET_USER_COUNTRY', 'No autenticado');
        commit('SET_BUCKET_NAME', 'No disponible');
      }
    },
    
    async fetchBucketInfo({ commit }) {
      try {
        // Obtener información del bucket (ruta vacía para obtener la raíz)
        const response = await axios.get(`${API_URL}/files/bucket`, {
          params: { folder: '' }
        });
        
        if (response.data && response.data.bucket_name) {
          commit('SET_BUCKET_NAME', response.data.bucket_name);
        }
        
        return response.data;
      } catch (error) {
        console.error('Error al obtener información del bucket:', error);
        return { error: error.response?.data?.detail || 'Error al obtener información del bucket' };
      }
    }
  }
} 